import { route } from '../../router';

// 当該プロジェクトでアクセスできるプロダクトが 1 つも無い場合に表示する画面。
// 旧 auth front (/auth/projects/$id) へリダイレクトすると、旧ロジック (group 非考慮の
// isProductEnabled) で当プロダクトへ差し戻されてループするため、auth へ飛ばさず
// プロダクト内でこの画面を表示してループを断ち切る。
export const NoAccessibleProduct: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <main className="relative overflow-auto">
        <div className="grid h-full items-center justify-center overflow-auto px-8 py-10 max-sm:px-6">
          <section className="text-center">
            <h1 className="mb-2 text-xl font-bold text-gray-900">利用できるプロダクトがありません</h1>
            <p className="mb-8 text-sm text-gray-600">
              このプロジェクトで利用できるプロダクトがありません。
              <br />
              アクセス権限についてはプロジェクト管理者にお問い合わせください。
            </p>
            <a
              href={route('/projects')}
              className="inline-flex items-center justify-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              プロジェクト一覧へ
            </a>
          </section>
        </div>
      </main>
    </div>
  );
};
